import NewsletterSixContainers from "./containers/NewsletterSixContainers";
export default NewsletterSixContainers;
